var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBuildingLightBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.754 36.754",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #6089bd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_915569_cc",
    transform: "translate(-5 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    className: "cls-1",
    d: "M42.137,89.084H16.817A.817.817,0,0,1,16,88.267v-2.45A.817.817,0,0,1,16.817,85h25.32a.817.817,0,0,1,.817.817v2.45A.817.817,0,0,1,42.137,89.084Zm-24.5-1.634H41.32v-.817H17.634Z",
    transform: "translate(-6.508 -47.329)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    className: "cls-1",
    d: "M42.686,82.492H19.817A.817.817,0,0,1,19,81.675V78.817A.817.817,0,0,1,19.817,78H42.686a.817.817,0,0,1,.817.817v2.859A.817.817,0,0,1,42.686,82.492ZM20.634,80.859H41.869V79.634H20.634Z",
    transform: "translate(-8.283 -43.188)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    className: "cls-1",
    d: "M42.686,53.492H19.817A.817.817,0,0,1,19,52.675V49.817A.817.817,0,0,1,19.817,49H42.686a.817.817,0,0,1,.817.817v2.859A.817.817,0,0,1,42.686,53.492ZM20.634,51.859H41.869V50.634H20.634Z",
    transform: "translate(-8.283 -26.031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    className: "cls-1",
    d: "M25.817,66.618A.817.817,0,0,1,25,65.8V56.817a.817.817,0,0,1,1.634,0V65.8A.817.817,0,0,1,25.817,66.618Z",
    transform: "translate(-11.832 -30.172)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    className: "cls-1",
    d: "M33.817,66.618A.817.817,0,0,1,33,65.8V56.817a.817.817,0,0,1,1.634,0V65.8A.817.817,0,0,1,33.817,66.618Z",
    transform: "translate(-16.565 -30.172)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    className: "cls-1",
    d: "M43.817,66.618A.817.817,0,0,1,43,65.8V56.817a.817.817,0,0,1,1.634,0V65.8A.817.817,0,0,1,43.817,66.618Z",
    transform: "translate(-22.481 -30.172)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    className: "cls-1",
    d: "M51.817,66.618A.817.817,0,0,1,51,65.8V56.817a.817.817,0,0,1,1.634,0V65.8A.817.817,0,0,1,51.817,66.618Z",
    transform: "translate(-27.214 -30.172)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    className: "cls-1",
    d: "M61.817,66.618A.817.817,0,0,1,61,65.8V56.817a.817.817,0,0,1,1.634,0V65.8A.817.817,0,0,1,61.817,66.618Z",
    transform: "translate(-33.131 -30.172)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    className: "cls-1",
    d: "M69.817,66.618A.817.817,0,0,1,69,65.8V56.817a.817.817,0,0,1,1.634,0V65.8A.817.817,0,0,1,69.817,66.618Z",
    transform: "translate(-37.863 -30.172)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    className: "cls-1",
    d: "M64.93,35.374a.817.817,0,0,1-.817-.817,6.481,6.481,0,0,0-.543-2.61.818.818,0,1,1,1.5-.657,8.106,8.106,0,0,1,.678,3.267A.817.817,0,0,1,64.93,35.374Z",
    transform: "translate(-34.61 -15.264)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    className: "cls-1",
    d: "M31.228,26.115a.817.817,0,0,1-.751-1.135,8.168,8.168,0,0,1,15.016-.09.818.818,0,1,1-1.5.653,6.534,6.534,0,0,0-12.015.069A.817.817,0,0,1,31.228,26.115Z",
    transform: "translate(-15.034 -8.864)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    className: "cls-1",
    d: "M29.817,35.444A.817.817,0,0,1,29,34.627a8.123,8.123,0,0,1,.641-3.181.817.817,0,1,1,1.5.637,6.5,6.5,0,0,0-.51,2.544.817.817,0,0,1-.817.817Z",
    transform: "translate(-14.199 -15.334)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    className: "cls-1",
    d: "M47.084,16.9a.817.817,0,0,1-.817-.817v-2.45H44.634v2.45a.817.817,0,1,1-1.634,0V12.817A.817.817,0,0,1,43.817,12h3.267a.817.817,0,0,1,.817.817v3.267A.817.817,0,0,1,47.084,16.9Z",
    transform: "translate(-22.481 -4.141)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    className: "cls-1",
    d: "M47.817,9.492A.817.817,0,0,1,47,8.675V5.817a.817.817,0,1,1,1.634,0V8.675A.817.817,0,0,1,47.817,9.492Z",
    transform: "translate(-24.848)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    className: "cls-1",
    d: "M10.309,70.744H5.817A.817.817,0,0,1,5,69.927V54.817A.817.817,0,0,1,5.817,54h5.309a.817.817,0,1,1,0,1.634H6.634V69.11h3.675a.817.817,0,1,1,0,1.634Z",
    transform: "translate(0 -28.989)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    className: "cls-1",
    d: "M83.534,70.744h-4.9a.817.817,0,1,1,0-1.634h4.084V55.634h-4.9a.817.817,0,0,1,0-1.634h5.717a.817.817,0,0,1,.817.817v15.11A.817.817,0,0,1,83.534,70.744Z",
    transform: "translate(-42.596 -28.989)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    className: "cls-1",
    d: "M14.817,68.084A.817.817,0,0,1,14,67.267v-2.45a.817.817,0,0,1,1.634,0v2.45A.817.817,0,0,1,14.817,68.084Z",
    transform: "translate(-5.325 -34.905)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    className: "cls-1",
    d: "M80.817,68.084A.817.817,0,0,1,80,67.267v-2.45a.817.817,0,0,1,1.634,0v2.45A.817.817,0,0,1,80.817,68.084Z",
    transform: "translate(-44.371 -34.905)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    className: "cls-1",
    d: "M29.817,43.717A.817.817,0,0,1,29,42.9V38.817a.817.817,0,0,1,1.634,0V42.9A.817.817,0,0,1,29.817,43.717Z",
    transform: "translate(-14.199 -19.523)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    className: "cls-1",
    d: "M65.817,43.717A.817.817,0,0,1,65,42.9V38.817a.817.817,0,0,1,1.634,0V42.9A.817.817,0,0,1,65.817,43.717Z",
    transform: "translate(-35.497 -19.523)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    className: "cls-1",
    d: "M44.519,39.634h-14.7a.817.817,0,1,1,0-1.634h14.7a.817.817,0,0,1,0,1.634Z",
    transform: "translate(-14.199 -19.523)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    className: "cls-1",
    d: "M37.817,41.769A.817.817,0,0,1,37,40.952V36.46a.817.817,0,0,1,.025-.2l.408-1.634a.818.818,0,1,1,1.585.408l-.384,1.523v4.39A.817.817,0,0,1,37.817,41.769Z",
    transform: "translate(-18.932 -17.166)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    className: "cls-1",
    d: "M47.817,41.759A.817.817,0,0,1,47,40.943V34.817a.817.817,0,0,1,1.634,0v6.126A.817.817,0,0,1,47.817,41.759Z",
    transform: "translate(-24.848 -17.157)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    className: "cls-1",
    d: "M57.223,41.751a.817.817,0,0,1-.817-.817v-4.39l-.384-1.536a.818.818,0,1,1,1.585-.408l.408,1.634a.817.817,0,0,1,.025.208v4.492A.817.817,0,0,1,57.223,41.751Z",
    transform: "translate(-30.17 -17.149)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBuildingLightBlue);
export default __webpack_public_path__ + "static/media/icon-building-light-blue.c8193b1e0494387ba2eac68680eee237.svg";
export { ForwardRef as ReactComponent };